import React, { useState, useRef } from "react";
import Slider from "react-slick";
import { leftArrow, rightArrow } from "../../../constants/icons";

const PostImageComponent = ({ className, postImageData }) => {
  const [showSlider, setShowSlider] = useState(false);
  const ref = useRef(null);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    afterChange: (current) => {
      setIsAtStart(current === 0);
      setIsAtEnd(current === postImageData.length - 1);
    },
  };

  const handleShowAllImages = () => {
    setShowSlider(true);
  };

  const handleNextSlide = () => {
    ref.current.slickNext();
  };

  const handlePrevSlide = () => {
    ref.current.slickPrev();
  };
  return (
    <>
      {!showSlider && (
        <div
          className={`${
            className || ""
          } post-img-wrapper border-radius-3 mb-2 ${
            postImageData.length === 1 ? "myk__stu-post-1" : ""
          } ${postImageData.length === 2 ? "myk__stu-post-2" : ""}`}
        >
          {postImageData.slice(0, 3).map((imgPost, index) => (
            <img
              key={index}
              src={imgPost.postImage}
              className="img-fluid w-100"
              alt="Post"
            />
          ))}
          {postImageData.length > 3 && (
            <div
              className="myk__stu-show-all-imgs"
              onClick={handleShowAllImages}
            >
              <span>
                + <strong>{postImageData.length - 2}</strong>
              </span>
            </div>
          )}
        </div>
      )}
      {showSlider && (
        <div className={`${className || ""} slider-comm_images-wrapper`}>
          <div className="myk_stu-carousel-action">
            <a
              href="javascript:void(0)"
              className={`btn-move btn-prev ${isAtStart ? "disabled" : ""}`}
              onClick={handlePrevSlide}
            >
              {leftArrow}
            </a>
            <a
              href="javascript:void(0)"
              className={`btn-move btn-btn-next ${isAtEnd ? "disabled" : ""}`}
              onClick={handleNextSlide}
            >
              {rightArrow}
            </a>
          </div>
          <Slider {...settings} ref={ref}>
            {postImageData.map((imgPost, index) => (
              <div key={index} className="item">
                <img
                  src={imgPost.postImage}
                  className="img-fluid w-100"
                  alt="Post"
                />
              </div>
            ))}
          </Slider>
        </div>
      )}
    </>
  );
};

export default PostImageComponent;
